(() => {
  if (customElements.get('gcs-single-door-product')) return;
  class SingleDoorProduct extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.addEventListener('change', event => {
        const input = event.target;
        if (input.matches('input[type="radio"][data-render]')) {
          this.querySelector('[data-single-image]').src = input.dataset.render;
          this.querySelector('[data-single-image]').alt = 'Single Door Vanity — ' + input.dataset.finish;
          this.querySelector('[data-single-finish]').textContent = input.dataset.finish;
          this.querySelector('[data-single-caption]').textContent = input.dataset.finish;
        }
        if (input.matches('[data-single-width]')) this.updatePrice();
        if (input.matches('[data-single-quantity]')) input.value = Math.max(1, Math.floor(Number(input.value) || 1));
      }, {signal:this.abort.signal});
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button) return;
        const input = this.querySelector('[data-single-quantity]');
        input.value = Math.max(1, (Math.floor(Number(input.value)) || 1) + Number(button.dataset.quantityStep));
      }, {signal:this.abort.signal});
      this.updatePrice();
    }
    updatePrice() {
      const option = this.querySelector('[data-single-width]').selectedOptions[0];
      this.querySelector('[data-single-price]').textContent = option?.dataset.price ? option.dataset.price + ' · Preview price' : 'Price to be confirmed';
    }
    disconnectedCallback() { this.abort?.abort(); }
  }
  customElements.define('gcs-single-door-product', SingleDoorProduct);
})();

